<script lang="ts">
	import { onMount, onDestroy } from 'svelte';
	import NavbarLogo from './NavbarLogo.svelte';
	import NavbarMenu from './NavbarMenu.svelte';
	import NavbarMenuMobile from './NavbarMenuMobile.svelte';
	import { user } from '$lib/user';

	let node;
	let isMobile = false;

	const handleOnResize = () => {
		isMobile = window.innerWidth < 1024; // Adjust the breakpoint as needed
	};

	// const handleOnResize = () => {
	// 	$width = $width;
	// };

	// Function to toggle the menu

	// Close the menu when clicking outside of it
	// function handleClickOutside(event) {
	// 	if (node && !node.contains(event.target)) {
	// 		isMenuOpen = false;
	// 	}
	// }

	onMount(() => {
		handleOnResize();
		window.addEventListener('resize', handleOnResize);
	});

	onDestroy(() => {
		window.removeEventListener('resize', handleOnResize);
	});
</script>

<svelte:window on:resize={handleOnResize} />

<div class="navbar" bind:this={node}></div>

<nav class="my-4 relative 3xl:max-w-full" data-sveltekit-preload-data="hover">
	<div class="flex items-center justify-between h-16">
		<NavbarLogo {user} />
		{#if isMobile}
			<NavbarMenuMobile />
		{:else}
			<NavbarMenu />
		{/if}
	</div>
	<!-- <div on:click={handleClickOutside} on:keyup={handleClickOutside} role="button" tabindex="0"> -->

	<!-- </div> -->
</nav>
